import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import {Match} from '../../models'
import template from './event.jade'
import '../status'
import '../match-times'
import '../event-selector'
import '../event-submitter'
import '../lineups'
import getState from '../../services/event-state'

@Component('sporty')
@Template(template)
@Attribute('match', Match)
export default class Event extends HTMLElement {
  attached() {
    this.matchChange()
  }
  matchChange() {
    this.detached()
    this.unlisten = this.state.listen(this)
  }
  detached() {
    if(this.unlisten) this.unlisten()
    delete this.unlisten
  }
  eventName(event) {
    return this.state.eventName(event)
  }
  subEvents(category) {
    return this.state
      .subEvents
      .filter(e => e.name === category)
  }
  count(category) {
    return this.state.countEvents(category)
  }
  max(category) {
    return this.state.maxEvents(category)
  }
  setState(category) {
    this.state.state = category
    this.render()
  }
  get state() {
    return getState(this.match)
  }
  get event() {
    return this.state.event
  }
  get subCategories() {
    return this.state.subCategories
  }
  get subs() {
    return this.state.subEvents
  }
}
